export const ACCESS_TOKEN = 'corporate-access-token';
export const USER_DETAILS = 'corporate-user-details';
export const SIDEBAR = 'corporate-sidebar';
